import { compact } from 'lodash/fp';
import { P, Strong } from '@ahmdigital/ui';

import constants from '../../../ahm-constants';

export default {
  description: (
    <P>
      You also get <Strong>60%</Strong> back at <Strong>your choice of recognised provider</Strong> on included{' '}
      <Strong>dental services</Strong>, and therapies such as <Strong>physio</Strong> and{' '}
      <Strong>remedial massage</Strong>, plus <Strong>100%</Strong> back on <Strong>optical</Strong>, up to your annual
      limits.
    </P>
  ),
  getSellingPoints: () =>
    compact([
      {
        description: 'up to your annual limit on included extras.',
        title: '60% back at your choice of recognised provider',
      },
      {
        description: 'Frames, prescription lenses and contact lenses included.',
        title: '100% back on optical',
      },
      {
        description: 'TAS and QLD residents are covered by their state schemes.',
        title: 'Emergency ambulance included',
      },
    ]),
  upgrade: {
    cta: 'Check out black 70',
    id: constants.PRODUCT.BLACK_70_EXTRAS,
    title: 'Looking for a higher percentage benefit?',
  },
};
